<template>
  <v-layout row justify-center>
    <v-dialog v-model="sendOneDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{title}}</v-card-title>
        <v-card-text>
          {{message}}
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="toggleDialog" :disabled="updating">Annuler</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click.prevent="sendEmail"
            :disabled="updating"
          >Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: [
    "sendOneDialog",
    "sendEmail",
    "toggleDialog",
    "updating",
    "title",
    "message"
  ]
};
</script>

